export default IconMath1Divide2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-math-1-divide-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 12h14" />
  <path d="M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3" />
  <path d="M10 5l2 -2v6" />
</svg>`;